import React from 'react';
import { components } from 'react-select';

/** Shared react-select styles for Configure → Business modals. */
export const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)',
        opacity: 0.6
    }),
    input: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        color: state.isSelected ? 'white' : 'var(--form-control-color)'
    })
};

export function IconLabel({ icon, label }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="tw-text-[#788097] dark:tw-text-white tw-shrink-0" style={{ display: 'inline-flex', alignItems: 'center' }}>
                {icon}
            </span>
            <span style={{ fontSize: '14px' }}>{label}</span>
        </div>
    );
}

export function makeIconComponents(icon) {
    return {
        Option: (props) => (
            <components.Option {...props}>
                <IconLabel icon={icon} label={props.data.label} />
            </components.Option>
        ),
        SingleValue: (props) => (
            <components.SingleValue {...props}>
                <IconLabel icon={icon} label={props.data.label} />
            </components.SingleValue>
        )
    };
}
